<app-page-head>
  <div class="col form mb-5">
    <!-- dropdown que filtra o input das pastas -->
    <div class="btn-group sc_ml_2">
      <button type="button" class="btn btn-sm btn-secondary dropdown-toggle dropdown-toggle-split"
        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <i class="fa fa-filter" aria-hidden="true"></i>
        <span class="sr-only">Toggle Dropdown</span>
      </button>
      <div class="dropdown-menu">
        <button class="dropdown-item" (click)="getFilterValue('Author', false)">
          <i class="fa fa-graduation-cap mr-1" aria-hidden="true"></i>
            Autor
        </button>
        <button class="dropdown-item" (click)="getFilterValue('Folder', true)">
          <i class="fa fa-briefcase mr-2" aria-hidden="true"></i>
            Pasta
        </button>
        <button class="dropdown-item" (click)="getFilterValue('Title', false)">
          <i class="fa fa-book mr-2" aria-hidden="true"></i>
            Título
        </button>
      </div>
    </div>

    <!-- Search form -->
    <form class="d-flex justify-content-start">
      <i class="fas fa-search" aria-hidden="true"></i>
      <input #searchInput class="form-control ml-3" type="text" placeholder="Buscar por {{ searchFieldPlaceholder }}" aria-label="Buscar" />
    </form>

  </div>
  <button type="button" class="button button-primary mb-5" (click)="newRepository()">
    NOVA PASTA
  </button>
</app-page-head>

<div class="d-flex justify-content-center" *ngIf="loading">
  <div class="spinner-border text-info" style="width: 3rem; height: 3rem;" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>

<div class="row" id="accordion">
  <!-- <div class="col-xl-12 col-md-12 mb-4" *ngFor="let item of projects?.data">
    <app-card-project [project]="item" [showDropdown]="false"></app-card-project>
  </div>
  <div class="col">
    <mat-paginator
      fxLayoutAlign="end end"
      [length]="page.total"
      [pageSize]="page.page"
      [pageSizeOptions]="pageSizeOptions"
      [pageIndex]="page.current"
      showFirstLastButtons
      (page)="pageEvent = getData($event)"
    ></mat-paginator>
  </div> -->
</div>

<div class="row" id="accordion" *ngIf="isFolder;else project_card">
  <div class="col-md-3" *ngFor="let repository of repositories?.data">
    <app-card-repository [repository]="repository" [isAuthor]="false"></app-card-repository>
  </div>
</div>
<ng-template #project_card>
  <div class="row" id="accordion">
    <div class="col-xl-12 col-md-12" *ngFor="let repository of repositories?.data">
      <app-card-project [project]="repository" [showDropdown]="false"></app-card-project>
    </div>
  </div>
</ng-template>
 
 
<div class="row">
  <div class="col">
    <mat-paginator [hidden]="isRepositoriesEmpty" [length]="page.total" [pageSize]="page.page"
      [pageSizeOptions]="pageSizeOptions" [pageIndex]="page.current" showFirstLastButtons
      (page)="pageEvent = getData($event)"></mat-paginator>
  </div>
</div>
